<template>
  <main class="l-container">
    <div class="l-container__inner">
       <h1>hogehoge</h1> <!-- 表示する市内のFlag管理 -->
      <!-- コンテンツ -->
      <slot name="body"></slot>
    </div>

    <common-breadcrumb />
  </main>
</template>

<script>
import MixinAPI from '@/plugins/mixin-api';
import IsMobile from '@/plugins/isMobile';
import CommonBreadcrumb from '@/components/parts/CommonBreadcrumb';
import CommonButton from '@/components/parts/button/CommonButton';
import CommonSelect from '@/components/parts/select/CommonSelect';

export default {
  name: 'CommonAssetsTemplate',
  mixins: [MixinAPI, IsMobile],
  components: {
    CommonBreadcrumb,
    CommonButton,
    CommonSelect,
  },
  data() {
    return {
      isMobile: false,
      isTablet: false,
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss">
// brake points 768px(tablet)/639px(sp)
@charset "UTF-8";
.l-container {
  padding: 0 20px;
  flex: 1 0 auto;
  background: #fafafa;

  &__inner {
    width: 100%;
    max-width: 980px;
    padding: 30px 30px 50px;
    margin: 30px auto 102px;
    border-radius: 20px;
    border: 1px solid #ccc;
    background: #fff;
  }
}
.c-heading {
  font-family: "メイリオ", "Meiryo", sans-serif;
  font-size: 20px;
  font-weight: bold;
  color: #666;
  text-align: center;
}

@media screen and (max-width: 768px) {
  .l-container {
    &__inner {
      margin-bottom: 20px;
    }
  }
}

@media screen and (max-width: 639px) {
  .l-container {
    &__inner {
      padding: 0;
      margin-bottom: 20px;
      border-radius: 0;
      border: 0;
      background: #fafafa;
    }
  }
}

</style>
